import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import List from './components/List'
import Update from './components/Update'
import Create from './components/Create'

const JobModule: RouteObject = {
    path: 'jobs',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: <Create />,
                },
                {
                    path: ':jobID',
                    element: <Update />,
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default JobModule
